import type { SampleContentManagementDto } from '../../react/features/Admin/SampleContentPage/types';
import { get, post } from '../request';

const BASE_URL = '/api/v2/sample-content';

export function getConfig(): Promise<SampleContentManagementDto> {
    return get(`${BASE_URL}/config`);
}

export function getStatus() {
    return get<boolean>(`${BASE_URL}/status`);
}

export function deleteSampleContent(): Promise<void> {
    return post(`${BASE_URL}/delete-sample-users`);
}

export function resetTrial(payload: SampleContentManagementDto): Promise<void> {
    return post(`${BASE_URL}/reset-trial`, {
        postData: payload,
    });
}

export function deleteAllContentIncludingCycles(payload: SampleContentManagementDto): Promise<void> {
    return post(`${BASE_URL}/delete-all`, {
        postData: payload,
    });
}
